export default __webpack_public_path__ + "static/media/barcode.d8b9b2cd.svg";